import JSX from "../../helpers/react.js";

export function LoadingSpinner({large, small}: { large?: boolean, small?: boolean }) {
    if (small) return (
        <div className="spinner" style="display: block;">
            <div className="bounce1"/>
            <div className="bounce2"/>
            <div className="bounce3"/>
        </div>
    );
    large ??= true;
    return (
        <div className={"loading center" + (large ? ' large' : '')} style={{width: "100%"}}>
            <i className="fa fa-spinner fa-spin"/>
        </div>
    )
}